import { useEffect, useState } from 'react';
import api from '../../utils/api';

export function useReceptionStaff() {
  const [staff, setStaff] = useState([]);

  useEffect(() => {
    api.get('/reception/staff')
      .then((res) => setStaff(res.data?.data?.items || []))
      .catch(() => setStaff([]));
  }, []);

  return staff;
}

export function useClasses() {
  const [classes, setClasses] = useState([]);

  useEffect(() => {
    api.get('/reception/classes')
      .then((res) => {
        const data = res.data?.data;
        setClasses(Array.isArray(data) ? data : data?.items || []);
      })
      .catch(() => setClasses([]));
  }, []);

  return classes;
}
